import { TeaserItem } from "@store/funnel/interfaces/teaserItem";
import { TeaserEcommerceItem } from "@store/funnel/interfaces/ecommerceItem/teaserEcommerceItem";

export function createEcommerceItemFromTeaserItem(teaserItem: TeaserItem, index: number = 0): TeaserEcommerceItem {
    return {
        affiliation: '',
        coupon: '',
        discount: 0,
        index: index,
        item_brand: teaserItem.organizerName,
        item_category: teaserItem.tripType,
        item_category2: '',
        item_category3: teaserItem.highlightTags.join('/'),
        item_category4: teaserItem.countryNames.join('/'),
        item_category5: '',
        item_id: teaserItem.uid,
        item_list_id: 'recommendations',
        item_list_name: 'trip_recommendation',
        item_name: teaserItem.title,
        item_variant: '',
        location_id: '',
        price: teaserItem.minPrice,
        quantity: 1
    } as TeaserEcommerceItem
}
